<template>
<div>
    <modal-component
        :show="show"
        @change="$emit('change',$event)"
        width="1400">
        <template v-slot:header>
            <span>Оплата единого платежного документа по пoстaвщикaм (исполнителям) услуг</span>
        </template>
        <template v-slot:main>
            <div class="modal-content">
                <div>
                    <v-table-wrapper
                        :headers="headers"
                        :items="providers">
                        <template v-slot:item.flag="{item}">
                            <v-checkbox
                                :input-value="checkedList[item.principalCode]"
                                color="success"
                                :disabled="loading"
                                @change="toPayChecked(item)" />
                        </template>
                        <template v-slot:item.principalInfo="{item}">
                            <div class="word-wrap">{{item.principalInfo}}</div>
                        </template>
                        <template v-slot:item.toPayInput="{item}">
                            <v-currency-field
                                :disabled="loading || !checkedList[item.principalCode]"
                                :value="valueByPrincipal[item.principalCode]"
                                outlined
                                :hide-details="true"
                                @input="sumChanged($event, item)">
                            </v-currency-field>
                        </template>
                    </v-table-wrapper>
                </div>
                <div class="payment-container align-center">
                    <div class="">
                        <span class="d-inline-block pr-3 helvetica-bold">Итого по ЕПД:</span>
                        <span class="d-inline-block helvetica-bold">{{ sumTotal || '0.00' }}</span>
                        <span class="rub-postfix d-inline-block px-3">руб.</span>
                    </div>
                    <div>
                        <span class="d-inline-block pr-3 helvetica-bold">Итого к оплате:</span>
                        <span class="d-inline-block helvetica-bold">{{ sumToPay || '0.00' }}</span>
                        <span class="rub-postfix d-inline-block px-3">руб.</span>
                        <v-btn
                            @click="pay"
                            :disabled="loading || !isOnline"
                            class="d-inline-block orange-button"
                            width="150">Оплатить
                        </v-btn>
                    </div>
                </div>
                <modal-payment-by-providers-info @answer="answerHandler" v-model="showModalPaymentByProvidersInfo" />
                <modal-payment
                    :toPay="sumToPay"
                    :details="payDetails"
                    v-if="showModalPayment"
                    v-model="showModalPayment" />
            </div>
        </template>
    </modal-component>
</div>
</template>

<script>
import VTableWrapper from "../wrapper/VTableWrapper";
import {
    mapState
} from "vuex";
import ModalPaymentByProvidersInfo from "./ModalPaymentByProvidersInfo";
import ModalComponent from "../common/Modal";
import ModalPayment from "./ModalPayment";
import VCurrencyField from "../common/VCurrencyField";

export default {
    name: "ModalPaymentByProviders",
    components: {
        VCurrencyField,
        ModalPayment,
        ModalComponent,
        ModalPaymentByProvidersInfo,
        VTableWrapper
    },
    model: {
        prop: "show",
        event: "change"
    },
    props: {
        month: {
            type: String
        },
        year: {
            type: String
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        headers: [{
                text: "Код исполнителя",
                value: "principalCode",
                isResizable: true
            },
            {
                text: "Наименование организации",
                value: "principalName",
                isResizable: true
            },
            {
                text: "Реквизиты исполнителя",
                value: "principalInfo",
                isResizable: true,
            },
            {
                text: "Сумма по ЕПД, руб",
                value: "toPay",
                isResizable: true
            },
            {
                text: "",
                value: "flag",
                isResizable: false,
                width: '50'
            },
            {
                text: "Сумма к оплате, руб",
                value: "toPayInput", // TODO
                isResizable: false
            }
        ],
        checkedList: {},
        valueByPrincipal: {},
        loading: false,
        showModalPaymentByProvidersInfo: false,
        showModalPayment: false,
        windowSize: {
            x: 0,
            y: 0
        }
    }),
    mounted() {
        this.onResize();
    },
    computed: {
        sumToPay() {
            let sum = 0
            for (let [key, value] of Object.entries(this.valueByPrincipal)) {
                if (this.checkedList[key]) sum = (sum * 100 + value * 100) / 100
            }
            return parseFloat(sum.toFixed(2))
        },
        payDetails() {
            let details = []
            for (let [key, value] of Object.entries(this.valueByPrincipal)) {
                details.push({
                    principalCode: key,
                    toPay: value
                })
            }
            return details
        },
        gotValidData(){
            return this.month && this.year;
        },
        sumTotal() {
            return parseFloat(this.providers.reduce((sum, el) => ((sum * 100 + el.toPay * 100) / 100), 0).toFixed(2))
        },
        ...mapState("account", ["selectedAccount"]),
        ...mapState("payments", ["providers"]),
        ...mapState("common", ["isOnline"]),
    },
    watch: {
        selectedAccount: {
            immediate: true,
            handler(val) {
                if(this.gotValidData){
                    this.doGetReceiptDetails();
                }
            }
        },
        gotValidData: {
            immediate: true,
            handler(val) {
                if(val){
                    this.doGetReceiptDetails();
                }
            }
        },
        isOnline(value) {
            if(value) {
                this.doGetReceiptDetails();
            }
        }
    },
    methods: {
        doGetReceiptDetails(){
              this.$store.dispatch("payments/getReceiptDetails", {
                    domHoz: this.selectedAccount.domHoz,
                    monthReceipt: Number(this.month),
                    yearReceipt: Number(this.year)
                }).then(() => {
                    this.valueByPrincipal = {}
                    this.checkedList = {}
                    this.providers.map(el => {
                        this.$set(this.checkedList, el.principalCode, true)
                        this.$set(this.valueByPrincipal, el.principalCode, el.toPay)
                    })
                });
        },
        answerHandler(flag) {
            this.showModalPayment = flag;
        },
        pay() {
            if(this.sumToPay <= 0) {
                this.$store.commit("common/ADD_ALERT", {
                    text: "Выберите поставщика и введите положительное число в колонке \"Сумма к оплате\"",
                    type: "error"
                });
            } else {
                this.showModalPaymentByProvidersInfo = true;
            }
        },
        onResize() {
            this.windowSize = {
                x: window.innerWidth,
                y: window.innerHeight
            };
        },
        toPayChecked(item) {
            if (this.checkedList[item.principalCode]) {
                this.$set(this.checkedList, item.principalCode, false)
                this.$set(this.valueByPrincipal, item.principalCode, 0)
            } else {
                this.$set(this.checkedList, item.principalCode, true)
                this.$set(this.valueByPrincipal, item.principalCode, item.toPay)
            }
        },
        sumChanged(val, item) {
            this.$set(this.valueByPrincipal, item.principalCode, Number(val))
        }
    }
};
</script>

<style lang="scss">
.word-wrap {
    width: 100%;
    display: block;
    white-space: normal;
    padding: 10px 0;
}

.modal-content {
    padding: 25px 20px;
}

.payment-container {
    margin-top: 25px;
    display: flex;
    position: relative;
    justify-content: space-between;
}
</style>
